import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {useForm} from "react-hook-form";
import clsx from "clsx";
import {Card, CardActions, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import Grid from "@mui/material/Grid";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import {tipoVaccino} from "../../../../../utils/arrays/Generics";
import {autocompleteRules, autocompleteRulesNotReq} from "../../../../../utils/RegisterUtils";
import {initVaccinazioniState, VACCINI_INITIAL_STATE, VacciniReducer} from "../../../../../reducers/VacciniReducer";
import {creaVaccinoManual} from "../../../../../services/VacciniServices";
import {AppContext} from "../../../../../App";
import {setOpenSnackbar} from "../../../../../services/AppServices";

const CreaVaccinoCard = ({idSoggetto}) => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const {handleSubmit, control, errors, reset} = useForm({mode: "onChange",});
	const [state, dispatch] = useReducer(VacciniReducer, VACCINI_INITIAL_STATE, initVaccinazioniState);
	const [submit, setSumbit] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setSumbit(true);
		creaVaccinoManual({
			...data,
			idSoggetto: idSoggetto,
		}, dispatch)
	}, [idSoggetto, dispatch]);
	
	useEffect(() => {
		if (submit && !state.loadingCreaVaccino && state.errorCreaVaccino === "") {
			setSumbit(false);
			setOpenSnackbar("success", "Vaccino creato correttamente", appContext.dispatch);
			reset({});
		} else if (submit && !state.loadingCreaVaccino && state.errorCreaVaccino !== "") {
			setSumbit(false);
			setOpenSnackbar("error", state.errorCreaVaccino, appContext.dispatch);
		}
	}, [submit, state.loadingCreaVaccino, state.errorCreaVaccino, appContext.dispatch, reset])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder, classes.transparent)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<CardHeader
						title={<Typography variant={"h6"}><b>Crea un vaccino</b></Typography>}
						subheader={"Segui le indicazioni per creare un vaccino da zero. Il vaccino non verrà considerato come certificato."}
					/>
					<CardContent style={{flexGrow: 1}}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={4}>
								<CustomDateInput
									label={"Prima dose"}
									control={control}
									defaultValue={null}
									maxDate={new Date()}
									rules={{required: true}}
									name={"dataPrimaDose"}
									error={errors["dataPrimaDose"]}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomDateInput
									label={"Seconda dose"}
									control={control}
									defaultValue={null}
									maxDate={new Date()}
									rules={{required: false}}
									name={"dataSecondaDose"}
									error={errors["dataSecondaDose"]}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomDateInput
									label={"Terza dose"}
									control={control}
									defaultValue={null}
									maxDate={new Date()}
									rules={{required: false}}
									name={"dataTerzaDose"}
									error={errors["dataTerzaDose"]}
								/>
							</Grid>
							
							<Grid item xs={12} sm={4}>
								<CustomAutoComplete
									label={"Tipo di vaccino 1"}
									control={control}
									options={tipoVaccino}
									multiple={false}
									rules={autocompleteRules}
									name={"tipoVaccinoPrimaDose"}
									error={errors["tipoVaccinoPrimaDose"]}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomAutoComplete
									label={"Tipo di vaccino 2"}
									control={control}
									options={tipoVaccino}
									multiple={false}
									rules={autocompleteRulesNotReq}
									name={"tipoVaccinoSecondaDose"}
									error={errors["tipoVaccinoSecondaDose"]}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<CustomAutoComplete
									label={"Tipo di vaccino 3"}
									control={control}
									options={tipoVaccino}
									multiple={false}
									rules={autocompleteRulesNotReq}
									name={"tipoVaccinoTerzaDose"}
									error={errors["tipoVaccinoTerzaDose"]}
								/>
							</Grid>
						</Grid>
					</CardContent>
					<CardActions className={classes.flexRight}>
						<Tooltip
							title={"Dopo aver controllato minuziosamente ogni singolo dato inserito, clicca su conferma per inviarlo al server che farà le magie."}>
							<Button variant={"contained"} disableElevation size="small" color="primary"
							        style={{borderRadius: 24}}
							        className={classes.roundButton} onClick={handleSubmit(onSubmit)}>
								<b>Conferma e crea</b>
							</Button>
						</Tooltip>
					</CardActions>
				</form>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(CreaVaccinoCard)
